<template>
    <div :class="classes" :role="role">
        <div :class="mdsNS('alert__cell-icon')">
            <svg :class="mdsNS('icon alert__icon')" aria-hidden="true">
                <use :xlink:href="iconId"></use>
            </svg>
        </div>
        <div :class="[mdsNS('alert__cell-body'), namespace('__message-info')]">
            <aside :class="mdsNS('alert__content')">{{ message }}</aside>
        </div>
        <button
            v-if="dismissible"
            :class="
                mdsNS(
                    'button button--small button--icon-only alert__dismiss-button'
                )
            "
            type="button"
            @click="close"
        >
            <svg
                :class="mdsNS('icon button__icon button__icon--right')"
                aria-hidden="true"
            >
                <use xlink:href="#remove--s">
                    <title>Remove</title>
                </use>
            </svg>
        </button>
    </div>
</template>
<script>
import utils from '../../utils';
import mixins from '../mixins';
export default {
    name: 'markets-ui-alert',
    mixins: [mixins],
    props: {
        message: {
            type: String,
            default: '',
            required: true
        },
        dismissible: {
            type: Boolean,
            default: false
        },
        dismissAutoly: {
            type: Number,
            default: 0
        },
        visible: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: '',
            validator(value) {
                return (
                    value === '' ||
                    utils.inArray(['error', 'warning', 'success'], value) > -1
                );
            }
        },
        tinted: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'medium',
            validator(value) {
                return utils.inArray(['medium', 'small'], value) > -1;
            }
        }
    },
    data() {
        return {
            dismissed: false
        };
    },
    created() {
        this.namespace = utils.namespace('ui-alert', false);
    },
    computed: {
        classes() {
            const cls = [this.namespace(), this.mdsNS('alert')];
            if (this.size) {
                cls.push(`${this.mdsNS('alert')}--${this.size}`);
            }
            if (this.tinted) {
                cls.push(`${this.mdsNS('alert')}--tinted`);
            }
            if (this.type) {
                cls.push(`${this.mdsNS('alert')}--${this.type}`);
            }
            if (this.dismissible) {
                cls.push(`${this.mdsNS('alert')}--dismissible`);
            }
            if (this.dismissed) {
                cls.push(`${this.mdsNS('alert')}--is-dismissed`);
            } else if (!this.visible) {
                cls.push(this.namespace('hide'));
            }
            if (this.skin) {
                cls.push(
                    `${this.namespace()}__${utils.getSkinSuffix(this.skin)}`
                );
            }
            return cls;
        },
        role() {
            if (this.type === 'alert') {
                return 'alert';
            } else {
                return 'alertdialog';
            }
        },
        iconId() {
            let icon = 'info-circle';
            switch (this.type) {
                case 'error':
                case 'warning':
                    icon = 'alert';
                    break;
                case 'success':
                    icon = 'check';
            }
            if (this.size === 'small') {
                icon = `${icon}--s`;
            }
            return `#${icon}`;
        }
    },
    watch: {
        visible(value) {
            if (value && this.dismissAutoly) {
                setTimeout(() => {
                    this.dismissed = true;
                    this.$emit('hide');
                }, this.dismissAutoly);
            } else {
                this.dismissed = false;
            }
        }
    },
    methods: {
        close() {
            this.dismissed = false;
            this.$emit('close');
        }
    }
};
</script>

<style lang="scss">
@import '../../mds/constants';
$namespace: 'markets-ui-alert';
.#{$namespace} {
    &-hide {
        display: none;
    }
    &__dark-gray {
        color: $mds-color-black;
        .#{$namespace}__message-info {
            background: $mds-background-color-dark-gray;
            color: $mds-text-color-primary-on-dark;
        }
    }
}
</style>
